import { KlaviyoMethods } from './klaviyo-methods';
export function openSMSPopup() {
  var trigger = document.querySelectorAll('.js-sms-open-popup');
  if (!trigger.length) return;
  trigger.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var formID = btn === null || btn === void 0 ? void 0 : btn.getAttribute('data-klaviyo-formid-desktop');
      if (window.innerWidth < 768) {
        formID = btn === null || btn === void 0 ? void 0 : btn.getAttribute('data-klaviyo-formid-mobile');
      }
      KlaviyoMethods.customTriggerPopup(formID);
    });
  });
}